import { useState } from "react";
import { ReactSession } from "react-client-session";
import { Link } from "react-router-dom";

import UserCard from "./UserCard";

import logo from "../../assets/logo.svg";
import user from "../../assets/user.svg";
import "./Header.css";

const Header = () => {
  const [toggleUserCard, setToggleUserCard] = useState(false);

  const userCardToggler = () => {
    setToggleUserCard(!toggleUserCard);
  };

  const role = ReactSession.get("role");

  return (
    <header className="header">
      <div className="logo">
        {role === "1" ? (
          <Link to="/admin">
            <img src={logo} alt="logo" className="header-logo" />
          </Link>
        ) : role === "2" ? (
          <Link to="/supervisor">
            <img src={logo} alt="logo" className="header-logo" />
          </Link>
        ) : role === "3" ? (
          <Link to="/operator">
            <img src={logo} alt="logo" className="header-logo" />
          </Link>
        ) : null}
      </div>

      {/* <div className="notification">
        <button className="button">
          <img
            src={notifications}
            alt="logo"
            className="helper-logo notification-logo"
          />
        </button>
      </div> */}

      <div onClick={userCardToggler} className="user">
        <button className="button">
          <img src={user} alt="logo" className="helper-logo user-logo" />
        </button>
      </div>
      {toggleUserCard && <UserCard />}
    </header>
  );
};

export default Header;
